import { get, isEmpty } from 'lodash';

export default errors => {
  const errorMessage = get(errors, 'description');
  const dataErrors = get(errors, `meta.validationErrors`, {});
  return Object.keys(dataErrors).reduce((acc, value) => {
    acc[value] = errorMessage;
    return acc;
  }, {});
};

export function getSystemError(errors) {
  return errors && isEmpty(errors.meta) && errors.description;
}



// WEBPACK FOOTER //
// ./src/components/PatientRegistration/utils/convertErrors.js